import { FC, ReactNode } from "react";

import { Icon } from "../../../general";
import { Body, Semibold } from "../../../typography";

import { IconButton } from "./IconButton";

import { ChatbotClassMap } from "../types";

type NoticeAppearance = "warning" | "info";

const APPEARANCE_ICON: Record<NoticeAppearance, "warning-circle" | "info-circle"> = {
  warning: "warning-circle",
  info: "info-circle",
};

interface Props {
  readonly styles: ChatbotClassMap;
  readonly content: ReactNode;
  readonly label?: ReactNode;
  readonly appearance?: NoticeAppearance;
  readonly dismissLabel?: string;
  readonly testId?: string;
  readonly onDismiss: () => void;
}

/** Dismissible advisory pinned above the transcript. Static guidance, so it is a note rather than a live region. */
export const DisclaimerNotice: FC<Props> = ({
  styles,
  content,
  label,
  appearance = "warning",
  dismissLabel = "Dismiss disclaimer",
  testId = "chatbot-disclaimer",
  onDismiss,
}) => (
  <div className={styles.DisclaimerNotice} role="note" data-appearance={appearance} data-testid={testId}>
    <Icon name={APPEARANCE_ICON[appearance]} className={styles.DisclaimerNoticeIcon} aria-hidden="true" />
    <Body>
      {!!label && (
        <>
          <Semibold>{label}</Semibold>
          {": "}
        </>
      )}
      {content}
    </Body>
    <IconButton
      icon="x-close"
      label={dismissLabel}
      tooltip="Dismiss"
      onClick={onDismiss}
      testId={`${testId}-dismiss`}
    />
  </div>
);
